import { isAxiosError } from "axios";

/** How many times a failed query is retried app-wide (the `QueryClient` default in `index.tsx`). */
export const QUERY_RETRY_COUNT = 2;

const HTTP_FORBIDDEN = 403;

/**
 * A query `retry` that gives up at once on a 403 — the viewer may not read it, and asking again only
 * delays the answer they will be shown — and otherwise retries like every other query.
 */
export const retryUnlessForbidden = (failureCount: number, error: Error): boolean =>
	!(isAxiosError(error) && error.response?.status === HTTP_FORBIDDEN) && failureCount < QUERY_RETRY_COUNT;
